import type { GetServerSideProps, NextPage } from 'next';

import businessCentreServerSideProps from '@oneflare-server-side-props/_businessCentrePage';
import ApolloRun from 'lib/utils/apolloRun';
import { compose } from 'lib/utils/compose';
import Category from 'pages/oneflare.com.au/BusinessCentre/Category';
import { GET_ALL_POSTS } from 'queries/oneflare.com.au/businessCentre';
import type { BusinessCentrePageProps } from 'types/oneflare.com.au/businessCentre';
import type { IGetAllPostsQueryDataModel } from 'types/shared';

type BusinessCentreCategoryType = BusinessCentrePageProps & IGetAllPostsQueryDataModel;

const BusinessCentreCategorypage: NextPage<BusinessCentreCategoryType> = (props) => { 
  return (
    <Category {...props} />
  );
};

const getServerSideProps: GetServerSideProps<BusinessCentreCategoryType> = compose(async (baseProps: Promise<{
  props: BusinessCentrePageProps & { params: { category: string }}
}>) => {
  const apolloRun = new ApolloRun();
  return baseProps.then(async ({ props }) => {
    const { params } = props;
    const { category: slug } = params;
    const getCategoryData = props?.getCategoryData;
    const [pageCategory]= getCategoryData.getCategory;
    const pageUrl = `/business-centre${(slug && `/${slug}`) || ''}/`;

    if (!pageCategory?.link) {
      return {
        notFound: true
      };
    }

    const [postsListData] = await apolloRun.query<IGetAllPostsQueryDataModel>(GET_ALL_POSTS, {
      limit: 100,
      exclude: 0,
      order: 'desc',
      orderby: 'date',
      categories: pageCategory?.categoryId
    });

    const getAllPost = postsListData?.getAllPost;

    // Need to ensure the page only renders a 200 status code
    // if the article URL matches what is define in WP
    const wpCategoryUrl = typeof URL !== 'undefined' ? new URL(pageCategory?.link) : null;
    if (wpCategoryUrl?.pathname?.replace('category/', '') !== pageUrl) {
      return {
        notFound: true
      };
    }

    return {
      props: {
        ...props,
        getAllPost,
        pageUrl: pageUrl.endsWith('/') ? pageUrl.slice(0, -1) : pageUrl
      }
    };
  });
}, businessCentreServerSideProps);

export { BusinessCentreCategorypage as default, getServerSideProps };
